import { render, staticRenderFns } from "./foreign-phone-input.pug?vue&type=template&id=20d3abed&lang=pug&external"
import script from "./foreign-phone-input.js?vue&type=script&lang=js&external"
export * from "./foreign-phone-input.js?vue&type=script&lang=js&external"
import style0 from "./foreign-phone-input.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports